import { messageForConnectionType } from '@tableau/catalog-ui-temp';
import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { FeatureFlags } from '~src/commonInfra/featureFlags/FeatureFlags';
import { getCommonTableInfo } from '~src/spacesPlatform/models/CommonTableInfo';
import { Tags } from '~src/tags/components/tooltips/Tags';

import { DetailsTooltipStyles } from '../card/DetailsTooltipStyles';
import { MarkupField } from '../Explorer/widgets/MarkupField';
import { BasicField } from './BasicField';
import { Name } from './Name';
import { Columns, Fields } from './TableColumns';
import { Tooltip } from './Tooltip';
import { ContentTooltipProps, TooltipDescriptionTestId } from './TooltipHelper';

export function TableTooltip(props: ContentTooltipProps): JSX.Element {
    const content = props.content;
    const tags = getTags(props.content.tags);
    const commonTable = getCommonTableInfo(content);
    const isDbServer: boolean = commonTable.dbType === 'DatabaseServer';
    const tableType = commonTable.tableType;
    return tableType !== 'DatabaseTable' && FeatureFlags.dataCloudInCatalogMVPEnabled ?
    (<Tooltip>
      <Name name={content.name} url={props.contentUrl}/>
      <MarkupField markup={content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]}/>
      <dl className={DetailsTooltipStyles.DescriptionList}>
        <Tags tags={tags}/>
        <BasicField name={Messages.tableTooltipSite()} value={commonTable.databaseName}/>
        <BasicField name={isDbServer ? Messages.tableTooltipConnectionType() : Messages.tableTooltipFileType()}
                    value={messageForConnectionType(commonTable.connectionType)}/>
        <Fields columns={commonTable.columns}/>
      </dl>
    </Tooltip>
) :(
    <Tooltip>
      <Name name={content.name} url={props.contentUrl}/>
      <MarkupField markup={content.description}
                   testId={TooltipDescriptionTestId}
                   extraClasses={[DetailsTooltipStyles.MetadataSectionWithContentDescription]}/>
      <dl className={DetailsTooltipStyles.DescriptionList}>
        <Tags tags={tags}/>
        <BasicField name={Messages.tableTooltipDatabaseName()} value={commonTable.databaseName}/>
        <BasicField name={isDbServer ? Messages.tableTooltipConnectionType() : Messages.tableTooltipFileType()}
                    value={messageForConnectionType(commonTable.connectionType)}/>
        <BasicField name={isDbServer ? Messages.tableTooltipHostname() : Messages.tableTooltipFilePath()}
                    value={isDbServer ? commonTable.hostName : commonTable.filePath}/>
        <Columns columns={commonTable.columns}/>
        <BasicField value={commonTable.contactName} name={Messages.tableTooltipContact()}/>
      </dl>
    </Tooltip>
);
}

function getTags(contentTags: any) {
  if (contentTags.length > 0) {
      if(typeof contentTags[0] === 'object') {
          return contentTags.map((tag: {name: any}) => { return tag.name;});
      }
  }
  return contentTags;
}